import {Pipe, PipeTransform} from '@angular/core';
import {parse, isAfter, isEqual} from 'date-fns';

@Pipe({ name: 'unlimitedDate' })
export class UnlimitedDatePipe implements PipeTransform {

  dateFormat = 'dd/MM/yyyy';

  transform(date: string, _args?: unknown): string {
    const parsedDate = parse(date, this.dateFormat, new Date());
    const latestDate = parse('31/12/2099', this.dateFormat, new Date());

    if (isAfter(parsedDate, latestDate) || isEqual(parsedDate, latestDate)) {
      return 'unlimited';
    } else {
      return date;
    }
  }

}
